/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const PlanTypeColumnFormatter = (cellContent, row, rowIndex) => {

  const titleCase = (str) => {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
  }
  return (
    <>
      {titleCase(cellContent)}
    </>
  );
}
